module.exports = __webpack_public_path__ + "img/img_introduction.51cd7a9a.png";